import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';
import { FieldVariableLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldVariableLabel';

defineBlock({
    type: 'var_get_string',
    colour: '#FF4081',
    tooltip: '文字列変数の値を取得します',
    movable: true,
    deletable: true,
    output: 'String',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('変数', { fontSize: 12, fontWeight: 'bold' }),
                },
                {
                    type: 'field',
                    name: 'VAR_LABEL',
                    instance: () =>
                        new FieldVariableLabel('str', { fontWeight: 'normal', varType: 'String', showSymbol: false }),
                },
            ],
        },
    ],
    onInit(this: Blockly.Block) {
        this.setOutputShape(3);
    },
});
